import axios from './axios';

export const customersAPI = {
  // Dashboard summary
  getDashboardSummary: async () => {
    const response = await axios.get('/customers/dashboard/summary');
    return response.data;
  },

  // CRUD operations
  getAll: async (params) => {
    const response = await axios.get('/customers', { params });
    return response.data;
  },

  // Convenience search by name/phone — used by point-of-sale lookups.
  search: async ({ query, limit = 10 } = {}) => {
    const response = await axios.get('/customers', {
      params: { search: query, limit, isActive: true },
    });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/customers/${id}`);
    return response.data;
  },

  getWithSubscription: async (id) => {
    const response = await axios.get(`/customers/${id}/with-subscription`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post('/customers', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`/customers/${id}`, data);
    return response.data;
  },

  deactivate: async (id) => {
    const response = await axios.delete(`/customers/${id}`);
    return response.data;
  },

  // Alias for backward compatibility
  delete: async (id) => {
    const response = await axios.delete(`/customers/${id}`);
    return response.data;
  },

  // Set credit limit (delegates to credit API but keeping here for convenience)
  setCreditLimit: async (id, creditLimit) => {
    const response = await axios.put(`/credit/${id}/limit`, { creditLimit });
    return response.data;
  }
};
